<!--  This component is written in TypeScript: ClearView Source\src\app\dashboard\modules\current-agent-states\agent-states-color-modal\agent-states-color-modal.component.html  -->
<!--  This component uses this Current Agent States Sass file: ClearView Source\src\app\dashboard\modules\current-agent-states\agent-states-color-modal\agent-states-color-modal.component.scss  -->

<div class="modal-header">
    <!-- MAYBE fontsize 18 -->
    <h6 class="modal-title font-size-20 d-flex justify-content-between">
        <span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Color_Modal_Title">Edit State Color</span>
    </h6>
    <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="onCancelClicked()">
        <svg class="icon-16">
            <use href='../App_Themes/clearview-default/icons/utility/close.svg#close'></use>
        </svg>
    </button>
</div>
<div class="modal-body pl-0"><!--  No left padding, so that the color circle aligns to the modal title  -->
    <div class="mb-4 position-relative d-flex align-items-center">
        <div class="color-circle position-absolute" [ngStyle]="{'background-color': currentColor}"></div>
        <div class="pl-4 text-truncate" title="{{ stateDisplayName }}">{{ stateDisplayName }}</div>
    </div>
    <div class="pl-4">
        <!--  Recent Color Swatches  -->
        <div class="recent-colors mb-3" *ngIf="groupedRecentColors[0]?.length">
            <div class="recent-colors-row d-flex flex-wrap mt-2" *ngFor=" let recentColorsGroup of groupedRecentColors">
                <div class="color-square clickable d-flex justify-content-center align-items-center" 
                    *ngFor="let color of recentColorsGroup; let first = first" 
                    (click)="currentColor = color" 
                    [class.ml-2]="!first" 
                    [ngStyle]="{'background-color': color}">
                    <div [hidden]="!(currentColor === color)">
                        <svg class="icon-12 fill-white">
                            <use href='../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark'></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <p-colorPicker [(ngModel)]="currentColor" [inline]="true" (onChange)="onColorChange($event)"></p-colorPicker>
        <!-- input text box bound to the color picker so users can type and copy hex color codes. -->
        <div>
            <input #colorBox [(ngModel)]="currentColor"
                (ngModelChange)="typeColor($event)" 
                class="sp-input" 
                type="text" 
                spellcheck="false" 
                style="padding: 4px; max-width: 70px; max-height: 25px; margin-left: 8px;">
        </div>
        <!--  Chrome doesn't send the mouseover event on disabled buttons, so the parent div is in charge of the uib-popover  -->
        <ng-template #popOver cvLocalizedText langSection="Current_Agent_States_Module" langKey="Use_Default_Color_Popover">Default color is being used.</ng-template>
        <div class="popover-container d-inline-block"
            [ngbPopover]="popOver"
            triggers="mouseenter:mouseleave"
            placement="right"
            [disablePopover]="currentColor !== defaultColor">
            <button type="button" class="use-default-color-btn btn btn-text p-0 ml-2" (click)="onDefaultColorClicked()" [disabled]="currentColor === defaultColor">
                <span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Use_Default_Color">Use Default Color</span>
            </button>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text mr-2" (click)="onCancelClicked()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()" [disabled]="isSaving">Save</button>
</div>
